import ProductActionValueGroup from "../../../../api/models/test-series/ProductActionValueGroup";
import SubstrateActionValueGroup from "../../../../api/models/test-series/SubstrateActionValueGroup";

export const getProductSampleIds = (productSampleReferences: ProductActionValueGroup[]): number[] => {
  return productSampleReferences.map((sampleReference) => sampleReference.productSampleId);
};

export const getSubstrateSampleIds = (substrateSampleReferences: SubstrateActionValueGroup[]): number[] => {
  return substrateSampleReferences.map((sampleReference) => sampleReference.substrateId);
};
